import type { PlayerData } from '../PlayersStats.types';

import PlayerInfo from './PlayerInfo';
import PlayerDoubleStat from './PlayerStat/PlayerDoubleStat';

interface PlayerStatCardRowProps {
  playerData: PlayerData;
}

export default function PlayerStatCardRow({ playerData }: PlayerStatCardRowProps) {
  return (
    <div className="col-span-5 grid grid-cols-subgrid min-h-[40px]">
      <PlayerInfo
        name={playerData.name}
        position={playerData.position}
        jerseySrc={playerData.jerseySrc}
        flagSrc={playerData.flagSrc}
      />
      <PlayerDoubleStat
        className="col-start-[stat-1]"
        firstStatValue={playerData.yellowCards || 0}
        secondStatValue={playerData.redCards || 0}
        isHome={playerData.isHome}
      />
    </div>
  );
}
